// extracted by mini-css-extract-plugin
export var aside = "SplitBody-module--aside--cae72";
export var container = "SplitBody-module--container--cc5a9";
export var isAsideOffset = "SplitBody-module--isAsideOffset--5ac8b";
export var main = "SplitBody-module--main--b5ac1";